module.exports = __webpack_public_path__ + "img/arrow_red_bottom_dummy.ddf04c22.png";